import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServices, useStores } from 'index';
import { getErrorMessage } from 'utilities/ErrorHelper';

type ResyncPayload = {
  categoryId: string;
  language: string;
};

export const useResyncTrackmanParameterCategoryTranslation = () => {
  const service = useServices().trackmanParameterCategoriesService;
  const queryClient = useQueryClient();
  const notificationsStore = useStores().notificationStore;

  return useMutation({
    mutationFn: ({ categoryId, language }: ResyncPayload) => service.resyncTranslation(categoryId, language),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['adminTrackmanParameterCategories'] });
      notificationsStore.addToast('success', 'Category translation resynced successfully', 'success');
    },
    onError: (error) => notificationsStore.addToast('error', getErrorMessage(error), 'error'),
  });
};
